import { Form, Select } from "antd";
import type React from "react";
import type { MemberAttribute } from "../../../../../shared/types/member.types";
import { useMemberAttributeContext } from "../../../providers/MemberAttributeContext";
import { FilterWrapper } from "../FilterWrapper";
import type { MemberAttributeFilterConfig } from "../types";

const { Option } = Select;

export const SingleExistenceSelectFilter: React.FC<{
	memberAttribute?: MemberAttribute;
	config?: MemberAttributeFilterConfig;
}> = (props) => {
	const memberAttributeContext = useMemberAttributeContext();
	const memberAttribute =
		props.memberAttribute || memberAttributeContext.memberAttribute;
	const config = props.config || memberAttributeContext.config;

	if (!memberAttribute.memberAttributeId) return null;
	const formItem = (
		<Form.Item
			help={config.showHelpText ? memberAttribute.label : undefined}
			name={`memberAttributeFilter${memberAttribute.memberAttributeId}`}
			className="mb-4 w-full"
		>
			<Select placeholder="選択してください" allowClear>
				<Option
					key={`memberAttributeFilter${memberAttribute.memberAttributeId}_0`}
					value="hasImage"
				>
					有り
				</Option>
				<Option
					key={`memberAttributeFilter${memberAttribute.memberAttributeId}_1`}
					value="noImage"
				>
					無し
				</Option>
			</Select>
		</Form.Item>
	);

	return (
		<FilterWrapper
			config={config}
			itemKey={`${memberAttribute.label}${memberAttribute.memberAttributeId}`}
		>
			{formItem}
		</FilterWrapper>
	);
};
